import { render, staticRenderFns } from "./localRescann.vue?vue&type=template&id=bf5a7dc6&scoped=true&"
import script from "./localRescann.vue?vue&type=script&lang=js&"
export * from "./localRescann.vue?vue&type=script&lang=js&"
import style0 from "./localRescann.vue?vue&type=style&index=0&id=bf5a7dc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5a7dc6",
  null
  
)

export default component.exports